module.exports = __webpack_public_path__ + "img/widePeepoHappyRightHeart.7257566c.gif";